import { ContentBox } from "@msuite/ui/app-shell";
import { useQueryState } from "@msuite/ui/libs/nuqs";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import type { Enums } from "@msuite/utils/types";
import { useCitadel } from "@/hooks/use-citadel";
import { client } from "@/hono";
import { InvoicesMenu } from "./invoices-menu";
import { columns } from "./table-config";

export function Invoices() {
	/** Hooks */
	const [invoicesStateQuery] = useQueryState("invoices-state", {
		defaultValue: "all",
		clearOnDefault: true,
	});

	/** Query */
	const { citadel } = useCitadel();

	// The navigation entry is already behind `read Invoice`, so a caller without it arrives here
	// only by typing the address. The query stays behind the same rule rather than firing and
	// toasting a 403 at them.
	const readIsDenied = !!citadel && citadel.cannot("read", "Invoice");

	const { data, refetch, isLoading, queryKey } = useQuery({
		queryKey: ["invoices", invoicesStateQuery],
		enabled: !readIsDenied,
		queryFn: async () => {
			const response = await client.projects.invoices.$get({
				query: {
					state: invoicesStateQuery as Enums<"outgoingInvoiceState">,
				},
			});
			const data = await responseHandler(response);
			return data.invoices;
		},
	});

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={data ?? []}
				columns={columns}
				initialPinningState={{
					start: ["number"],
				}}
				persistenceKey="project-invoices-table"
				queryKey={queryKey}
				isLoading={isLoading}
				menu={<InvoicesMenu />}
				refetch={refetch}
			/>
		</ContentBox>
	);
}
